// Central apps registry. All apps available on both iOS and Android.
// Replace '#' in appStoreUrl / googlePlayUrl with real links when ready.

export const APPS = [
  {
    slug: 'whitenoise',
    name: 'White Noise: Calm Sleep',
    nameIos: 'White Noise: Calm Sleep',
    nameAndroid: 'White Noise: Calm Sleep',
    tagline: 'Peaceful ambient sounds for better sleep',
    description:
      'Fall asleep faster, focus deeper, stress less. 30+ ambient sounds — rain, ocean, fire, forest — play quietly in the background while you rest, work, or recharge. Sleep timer, sound mixer, zero clutter. Your personal quiet, always one tap away.',
    platforms: ['ios', 'android'],
    appStoreUrl: '#',
    googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.whiteapps.whitenoise',
    icon: '/designs/icons/white_noice.avif',
    accentColor: '#4A90D9',
    features: ['30+ ambient sound presets', 'Sleep timer with fade-out', 'Mix multiple sounds', 'Offline playback'],
    screenshots: [
      '/designs/White%20Noise_%20Calm%20Sleep%20(4)/01.avif',
      '/designs/White%20Noise_%20Calm%20Sleep%20(4)/02.avif',
      '/designs/White%20Noise_%20Calm%20Sleep%20(4)/03.avif',
      '/designs/White%20Noise_%20Calm%20Sleep%20(4)/04.avif',
      '/designs/White%20Noise_%20Calm%20Sleep%20(4)/05.avif',
    ],
    privacyPath: '/apps/whitenoise/privacy',
    termsPath: '/apps/whitenoise/termofuse',
    accountRemovePath: '/apps/whitenoise/accountremove',
  },
  {
    slug: 'qrbarcode',
    name: 'QR & Barcode',
    nameIos: 'QR & Barcode: Fast Reader Pro',
    nameAndroid: 'QR & Barcode Generator',
    tagline: 'Fast and accurate scanner for any code',
    description:
      'Scan any QR code or barcode in under a second — open links, join Wi-Fi, save contacts, decode product info. Then flip it around: generate your own QR codes for anything. The fastest bridge between the physical world and your phone.',
    platforms: ['ios', 'android'],
    appStoreUrl: 'https://apps.apple.com/us/app/qr-barcode-fast-reader-pro/id6755293465',
    googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.whiteapps.qrbarcode.reader',
    icon: '/designs/icons/QR_barcode.avif',
    accentColor: '#E85D04',
    features: ['Scan all QR & barcode formats', 'QR code generator', 'History of scanned codes', 'Flashlight support'],
    screenshots: [
      '/designs/QR%20%26%20Barcode%20Scanner%20%2B%20Generator%20(2)/01.avif',
      '/designs/QR%20%26%20Barcode%20Scanner%20%2B%20Generator%20(2)/02.avif',
      '/designs/QR%20%26%20Barcode%20Scanner%20%2B%20Generator%20(2)/03.avif',
      '/designs/QR%20%26%20Barcode%20Scanner%20%2B%20Generator%20(2)/04.avif',
      '/designs/QR%20%26%20Barcode%20Scanner%20%2B%20Generator%20(2)/05.avif',
    ],
    privacyPath: '/apps/qrbarcode/privacy',
    termsPath: '/apps/qrbarcode/termofuse',
    accountRemovePath: '/apps/qrbarcode/accountremove',
  },
  {
    slug: 'smartgps',
    name: 'Smart GPS Compass',
    nameIos: 'Smart GPS Compass',
    nameAndroid: 'Smart gps compass',
    tagline: 'Navigation and compass for outdoor adventures',
    description:
      'Always know exactly where you\'re headed. Real-time compass with true North, live GPS coordinates, altitude, speed, and signal accuracy — all in a clean interface built for hikers, travelers, and anyone who refuses to get lost.',
    platforms: ['ios', 'android'],
    appStoreUrl: 'https://apps.apple.com/us/app/smart-gps-compass/id6755293481',
    googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.whiteapps.compass.gps',
    icon: '/designs/icons/compass.avif',
    accentColor: '#2EC4B6',
    features: ['Real-time GPS tracking', 'Compass with true & magnetic north', 'Altitude & speed readout', 'Offline maps'],
    screenshots: [
      '/designs/Smart%20GPS%20Compass/01.avif',
      '/designs/Smart%20GPS%20Compass/02.avif',
      '/designs/Smart%20GPS%20Compass/03.avif',
      '/designs/Smart%20GPS%20Compass/04.avif',
      '/designs/Smart%20GPS%20Compass/05.avif',
    ],
    privacyPath: '/apps/smartgps/privacy',
    termsPath: '/apps/smartgps/termofuse',
    accountRemovePath: '/apps/smartgps/accountremove',
  },
  {
    slug: 'notespark',
    name: 'Note Spark: AI Note Taker',
    nameIos: 'Note Spark: Ai Note Taker',
    nameAndroid: 'Note Spark: Ai Note Taker',
    tagline: 'Record, transcribe, and summarize with AI',
    description:
      'Stop typing — start speaking. Record any meeting, lecture, or idea and get an AI-generated transcript plus smart summary in seconds. Your voice becomes organized, searchable, shareable notes. Never miss a word that matters again.',
    platforms: ['ios', 'android'],
    appStoreUrl: '#',
    googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.noteapps.notespark',
    icon: '/designs/icons/note_spark.avif',
    accentColor: '#9559FC',
    features: ['Voice-to-text transcription', 'AI-powered summaries', 'Export to PDF & TXT', 'Cloud sync'],
    screenshots: [
      '/designs/NoteSpark_%20AI%20Note%20Taker%20(2)/01.avif',
      '/designs/NoteSpark_%20AI%20Note%20Taker%20(2)/02.avif',
      '/designs/NoteSpark_%20AI%20Note%20Taker%20(2)/03.avif',
      '/designs/NoteSpark_%20AI%20Note%20Taker%20(2)/04.avif',
      '/designs/NoteSpark_%20AI%20Note%20Taker%20(2)/05.avif',
    ],
    privacyPath: '/apps/notespark/privacy',
    termsPath: '/apps/notespark/termofuse',
    accountRemovePath: '/apps/notespark/accountremove',
  },
  {
    slug: 'veilify',
    name: 'Veilify Photo Vault',
    nameIos: 'Veilify: Private Photo Vault',
    nameAndroid: 'Veilify Photo Vault',
    tagline: 'Protect your private photos & videos',
    description:
      'Your most private photos deserve real protection. Lock them behind Face ID or a PIN in an encrypted vault, organize into hidden albums, and keep them completely invisible to anyone who picks up your phone.',
    platforms: ['ios', 'android'],
    appStoreUrl: '#',
    googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.photovault.verify',
    icon: '/designs/icons/Photo_vaylt.avif',
    accentColor: '#7209B7',
    features: ['AES-256 encryption', 'Face ID / fingerprint unlock', 'Decoy passcode mode', 'Secure cloud backup'],
    screenshots: [
      '/designs/Veilify%20Photo%20Vault/01.avif',
      '/designs/Veilify%20Photo%20Vault/02.avif',
      '/designs/Veilify%20Photo%20Vault/03.avif',
      '/designs/Veilify%20Photo%20Vault/04.avif',
      '/designs/Veilify%20Photo%20Vault/05.avif',
    ],
    privacyPath: '/apps/photo_vaylt/privacy',
    termsPath: '/apps/Photo_vaylt/termofuse',
    accountRemovePath: '/apps/photo_vaylt/accountremove',
  },
  {
    slug: 'caloriecounter',
    name: 'AI Calorie Counter',
    nameIos: 'NutriFocus: AI Calorie Tracker',
    nameAndroid: 'Ai Calorie counter',
    tagline: 'Track nutrition with AI food recognition',
    description:
      'Point. Log. Know. AI reads your meal from a photo and instantly breaks down calories, protein, carbs, and fat. Set your daily goal, track every bite, and finally understand exactly what you\'re eating — without the guesswork.',
    platforms: ['ios', 'android'],
    appStoreUrl: '#',
    googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.ignatkin.calorie',
    icon: '/designs/icons/AI_calorie.avif',
    accentColor: '#80B918',
    features: ['AI food recognition from photo', 'Full macro & micro tracking', 'Daily & weekly reports', 'Water intake tracker'],
    screenshots: [
      '/designs/Smart%20Calorie%20%E2%80%94%20AI%20Food%20(1)/01.avif',
      '/designs/Smart%20Calorie%20%E2%80%94%20AI%20Food%20(1)/02.avif',
      '/designs/Smart%20Calorie%20%E2%80%94%20AI%20Food%20(1)/03.avif',
      '/designs/Smart%20Calorie%20%E2%80%94%20AI%20Food%20(1)/04.avif',
      '/designs/Smart%20Calorie%20%E2%80%94%20AI%20Food%20(1)/05.avif',
    ],
    privacyPath: '/apps/colorie_counter/privacy',
    termsPath: '/apps/Colorie_Counter/termofuse',
    accountRemovePath: '/apps/colorie_counter/accountremove',
  },
  {
    slug: 'invoicemaker',
    name: 'Invoice Maker',
    nameIos: 'Contractor Invoice Maker App',
    nameAndroid: 'Invoice Maker',
    tagline: 'Create professional invoices in seconds',
    description:
      'Professional invoices in 60 seconds, straight from your phone. Add your logo, line items, tax, and discount — then export a polished PDF and send it to your client on the spot. Billing that looks like you mean business.',
    platforms: ['ios', 'android'],
    appStoreUrl: '#',
    googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.goodwave.invoicemaker',
    icon: '/designs/icons/invoice_maker.avif',
    accentColor: '#1B998B',
    features: ['Professional PDF invoices', 'Client & product database', 'Payment tracking', 'Multiple currencies'],
    screenshots: [
      '/designs/Invoice%20Maker%20for%20Contractors%20(2)/01.avif',
      '/designs/Invoice%20Maker%20for%20Contractors%20(2)/02.avif',
      '/designs/Invoice%20Maker%20for%20Contractors%20(2)/03.avif',
      '/designs/Invoice%20Maker%20for%20Contractors%20(2)/04.avif',
      '/designs/Invoice%20Maker%20for%20Contractors%20(2)/05.avif',
    ],
    privacyPath: '/apps/invoice_maker/privacy',
    termsPath: '/apps/Invoice_maker/termofuse',
    accountRemovePath: '/apps/invoice_maker/accountremove',
  },
  {
    slug: 'pupverse',
    name: 'Pupverse: Dog Training',
    nameIos: 'Pupverse: Dog Training',
    nameAndroid: 'Pupverse: Dog Training',
    tagline: 'Train your dog with fun, science-based methods',
    description:
      'Raising a dog is easier when you actually know what you\'re doing. AI-powered training tips, daily reminders, health records, vet-clinic finder, and multi-dog support — everything a dog parent needs to build better habits and a stronger bond.',
    platforms: ['ios', 'android'],
    appStoreUrl: 'https://apps.apple.com/us/app/pupverse-dog-training/id6746752750',
    googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.app.pupverse',
    icon: '/designs/icons/pupverse.avif',
    accentColor: '#F9844A',
    features: ['200+ training lessons', 'Breed-specific programs', 'Progress tracking', 'Expert vet tips'],
    screenshots: [
      '/designs/PupVerse%20(1)/01.avif',
      '/designs/PupVerse%20(1)/02.avif',
      '/designs/PupVerse%20(1)/03.avif',
      '/designs/PupVerse%20(1)/04.avif',
      '/designs/PupVerse%20(1)/05.avif',
    ],
    privacyPath: '/apps/pupverse/privacy',
    termsPath: '/apps/pupverse/termofuse',
    accountRemovePath: '/apps/pupverse/accountremove',
  },
  {
    slug: 'wishflow',
    name: 'WishFlow',
    nameIos: 'WishFlow: Smart Wishlist',
    nameAndroid: 'WishFlow',
    tagline: 'Organize your wishlist and track your goals',
    description:
      'Stop losing gift ideas in browser tabs and chat messages. Save products from any store, organize by occasion, track prices, and share a clean wishlist link with anyone. The smartest way to want things — and actually get them.',
    platforms: ['ios', 'android'],
    appStoreUrl: 'https://apps.apple.com/us/app/wishflow-smart-wishlist/id6759678276',
    googlePlayUrl: '#',
    icon: '/designs/icons/wishflow.avif',
    accentColor: '#E040FB',
    features: ['Unlimited wishlists', 'Share with friends & family', 'Price tracking', 'Goal progress bar'],
    screenshots: [
      '/designs/WishFlow%20(2)/01.avif',
      '/designs/WishFlow%20(2)/02.avif',
      '/designs/WishFlow%20(2)/03.avif',
      '/designs/WishFlow%20(2)/04.avif',
      '/designs/WishFlow%20(2)/05.avif',
    ],
    privacyPath: '/apps/wishflow/privacy',
    termsPath: '/apps/WishFlow/termofuse',
    accountRemovePath: '/apps/wishflow/accountremove',
  },
  {
    slug: 'seektalk',
    name: 'Seek Talk',
    nameIos: 'Seek Talk Chat',
    nameAndroid: 'Seek Talk',
    tagline: 'Your smart AI assistant for any question',
    description:
      'Your smartest conversation partner — available 24/7. Ask anything, write better emails, summarize long texts, plan projects, debug code, or brainstorm ideas. Powered by the latest AI models and built for real, everyday productivity.',
    platforms: ['ios', 'android'],
    appStoreUrl: '#',
    googlePlayUrl: '#',
    icon: '/designs/icons/SeekTalk.avif',
    accentColor: '#3A86FF',
    features: ['Powered by latest AI models', 'Chat history & search', 'Code & creative writing', 'Multi-language support'],
    screenshots: [
      '/designs/Seek%20Talk%20(1)/01.avif',
      '/designs/Seek%20Talk%20(1)/02.avif',
      '/designs/Seek%20Talk%20(1)/03.avif',
      '/designs/Seek%20Talk%20(1)/04.avif',
      '/designs/Seek%20Talk%20(1)/05.avif',
    ],
    privacyPath: '/apps/seekaichat/privacy',
    termsPath: '/apps/seekaichat/termofuse',
    accountRemovePath: '/apps/seekaichat/accountremove',
  },
  {
    slug: 'nolatalk',
    name: 'Nola Talk',
    nameIos: 'Nola Talk: Chat Friend',
    nameAndroid: 'Nola Tallk',
    tagline: 'Your personal AI companion',
    description:
      'Not just a chatbot — a companion that feels personal. Choose her name, pick her look, and chat your way through writing tasks, study sessions, planning, or just a thought you need to untangle. Smart, friendly, always there.',
    platforms: ['ios', 'android'],
    appStoreUrl: '#',
    googlePlayUrl: '#',
    icon: '/designs/icons/Nola_Talk.avif',
    accentColor: '#FF6B6B',
    features: ['Personalized conversations', 'Mood tracking', 'Daily check-ins', 'Memory of past chats'],
    screenshots: [
      '/designs/Nola/01.avif',
      '/designs/Nola/02.avif',
      '/designs/Nola/03.avif',
      '/designs/Nola/04.avif',
      '/designs/Nola/05.avif',
    ],
    privacyPath: '/apps/Nola/privacy',
    termsPath: '/apps/Nola/termofuse',
    accountRemovePath: '/apps/nola/accountremove',
  },
  {
    slug: 'puretrackervaping',
    name: 'PureTracker: Quit Vaping',
    nameIos: 'PureTracker: Quit Vaping',
    nameAndroid: 'PureTracker: Quit Vaping',
    tagline: 'Break free from vaping, day by day',
    description:
      'Every day without vaping is a win worth seeing. Track your streak, watch your savings grow, log cravings, journal your journey, and get AI motivation exactly when the urge hits hardest. One app, one commitment, one day at a time.',
    platforms: ['ios', 'android'],
    appStoreUrl: '#',
    googlePlayUrl: '#',
    icon: '/designs/icons/vaping.avif',
    accentColor: '#43AA8B',
    features: ['Craving timer & tracker', 'Money & health saved stats', 'Daily motivation streaks', 'Community support'],
    screenshots: [
      '/designs/PureTracker_%20Quit%20Vaping%20(1)/01.avif',
      '/designs/PureTracker_%20Quit%20Vaping%20(1)/02.avif',
      '/designs/PureTracker_%20Quit%20Vaping%20(1)/03.avif',
      '/designs/PureTracker_%20Quit%20Vaping%20(1)/04.avif',
      '/designs/PureTracker_%20Quit%20Vaping%20(1)/05.avif',
    ],
    privacyPath: '/apps/puretrackervaping/privacy',
    termsPath: '/apps/PureTrackerVaping/termofuse',
    accountRemovePath: '/apps/puretrackervaping/accountremove',
  },
  {
    slug: 'puretrackerdrinking',
    name: 'PureTracker: Quit Drinking',
    nameIos: 'PureTracker: Quit Drinking',
    nameAndroid: 'PureTracker: Quit Drinking',
    tagline: 'Your sober journey, one day at a time',
    description:
      'Sobriety looks different every day — this app tracks all of it. Log your sober streak, watch your savings add up, write daily reflections, and tap into AI support when cravings push back. Your personal accountability partner, always in your pocket.',
    platforms: ['ios', 'android'],
    appStoreUrl: '#',
    googlePlayUrl: '#',
    icon: '/designs/icons/drinking.avif',
    accentColor: '#277DA1',
    features: ['Sobriety day counter', 'Craving journal', 'Health & finance stats', 'Personalized relapse plan'],
    screenshots: [
      '/designs/PureTracker_%20Quit%20Drinking%20(1)/01.avif',
      '/designs/PureTracker_%20Quit%20Drinking%20(1)/02.avif',
      '/designs/PureTracker_%20Quit%20Drinking%20(1)/03.avif',
      '/designs/PureTracker_%20Quit%20Drinking%20(1)/04.avif',
      '/designs/PureTracker_%20Quit%20Drinking%20(1)/05.avif',
    ],
    privacyPath: '/apps/puretrackerdrinking/privacy',
    termsPath: '/apps/PureTrackerDrinking/termofuse',
    accountRemovePath: '/apps/puretrackerdrinking/accountremove',
  },
  {
    slug: 'smartcollage',
    name: 'Smart Collage',
    nameIos: 'Smart Collage',
    nameAndroid: 'Smart Collage',
    tagline: 'AI-powered collages from your photos',
    description:
      'Turn any set of photos into something worth sharing. Pick a ready-made grid or go completely freestyle — adjust backgrounds, tweak borders, and export a crisp 1080px image ready for Instagram, Pinterest, or anywhere your creativity lives.',
    platforms: ['ios', 'android'],
    appStoreUrl: '#',
    googlePlayUrl: '#',
    icon: '/designs/icons/SmartCollage.avif',
    accentColor: '#FF9F1C',
    features: ['AI layout generator', '500+ templates', 'Stickers & text overlays', 'Share to social media'],
    screenshots: [
      '/designs/Smart%20Collage%20AI/01.avif',
      '/designs/Smart%20Collage%20AI/02.avif',
      '/designs/Smart%20Collage%20AI/03.avif',
      '/designs/Smart%20Collage%20AI/04.avif',
      '/designs/Smart%20Collage%20AI/05.avif',
    ],
    privacyPath: '/apps/collage_ai/privacy',
    termsPath: '/apps/Collage_Ai/termofuse',
    accountRemovePath: '/apps/collage_ai/accountremove',
  },
  {
    slug: 'voiceeffect',
    name: 'Voice Effect Studia',
    nameIos: 'Voice Effect Studia',
    nameAndroid: 'Voice Effect Studia',
    tagline: 'Transform your voice with real-time effects',
    description:
      'Record your voice, then transform it into something completely different. Robot, chipmunk, monster, alien, echo, reverb, vintage radio — apply any effect instantly, preview the result, and export as MP3 or WAV. Clips, memes, characters — get creative.',
    platforms: ['ios', 'android'],
    appStoreUrl: '#',
    googlePlayUrl: '#',
    icon: '/designs/icons/voice_changer.avif',
    accentColor: '#F4A261',
    features: ['50+ real-time voice effects', 'Record & share clips', 'Works in any app', 'Background noise removal'],
    screenshots: [
      '/designs/Voice%20changer%20pro%20(1)/01.avif',
      '/designs/Voice%20changer%20pro%20(1)/02.avif',
      '/designs/Voice%20changer%20pro%20(1)/03.avif',
      '/designs/Voice%20changer%20pro%20(1)/04.avif',
      '/designs/Voice%20changer%20pro%20(1)/05.avif',
    ],
    privacyPath: '/apps/voice_changer/privacy',
    termsPath: '/apps/Voice_changer/termofuse',
    accountRemovePath: '/apps/voice_changer/accountremove',
  },
  {
    slug: 'studymath',
    name: 'StudyMath',
    nameIos: 'StudyMath',
    nameAndroid: 'StudyMath',
    tagline: 'AI-powered math solver for every level',
    description:
      'Stuck on a problem? Just snap it. AI reads your homework and delivers a clear, step-by-step explanation that teaches you the method — not just the answer. From basic algebra to calculus, study smarter and actually understand the math.',
    platforms: ['ios', 'android'],
    appStoreUrl: '#',
    googlePlayUrl: '#',
    icon: '/designs/icons/HWsolver.avif',
    accentColor: '#7C3AED',
    features: ['AI math problem solver', 'Step-by-step explanations', 'All levels: algebra to calculus', 'Practice problem generator'],
    screenshots: [
      '/designs/Homework%20AI%20Solver/01.avif',
      '/designs/Homework%20AI%20Solver/02.avif',
      '/designs/Homework%20AI%20Solver/03.avif',
      '/designs/Homework%20AI%20Solver/04.avif',
      '/designs/Homework%20AI%20Solver/05.avif',
    ],
    privacyPath: '/apps/hwsolver/privacy',
    termsPath: '/apps/HWsolver/termofuse',
    accountRemovePath: '/apps/hwsolver/accountremove',
  },
  {
    slug: 'privacyscan',
    name: 'Privacy Scan',
    nameIos: 'Privacy Scan',
    nameAndroid: 'Privacy Scan',
    tagline: 'Detect hidden cameras and spy devices',
    description:
      'Before you trust a room, scan it. Use your phone\'s camera and magnetometer to check for hidden camera lenses and suspicious magnetic signals in hotel rooms, rentals, changing rooms, or any space that doesn\'t feel quite right.',
    platforms: ['ios', 'android'],
    appStoreUrl: '#',
    googlePlayUrl: '#',
    icon: '/designs/icons/privacy_scan.avif',
    accentColor: '#0369A1',
    features: ['Hidden camera detector', 'RF signal scanner', 'Magnetic field meter', 'Step-by-step room scan'],
    screenshots: [
      '/designs/Privacy%20Scan/01.avif',
      '/designs/Privacy%20Scan/02.avif',
      '/designs/Privacy%20Scan/03.avif',
      '/designs/Privacy%20Scan/04.avif',
      '/designs/Privacy%20Scan/05.avif',
    ],
    privacyPath: '/apps/smart_spy/privacy',
    termsPath: '/apps/Smart_spy/termofuse',
    accountRemovePath: '/apps/smart_spy/accountremove',
  },
  {
    slug: 'traderlab',
    name: 'Trader Lab',
    nameIos: 'Trader Lab',
    nameAndroid: 'Trader Lab',
    tagline: 'Advanced market analysis for traders',
    description:
      'Learn to trade before you trade. Structured video lessons on chart reading, market structure, candlestick patterns, risk management, and trading psychology — real education from a real trader, built for beginners who are actually serious about it.',
    platforms: ['ios', 'android'],
    appStoreUrl: '#',
    googlePlayUrl: '#',
    icon: '/designs/icons/trader%20lab.avif',
    accentColor: '#00B4D8',
    features: ['Real-time price charts', 'Technical indicators', 'Portfolio tracker', 'AI market signals'],
    screenshots: [
      '/designs/TraderLab/01.avif',
      '/designs/TraderLab/02.avif',
      '/designs/TraderLab/03.avif',
      '/designs/TraderLab/04.avif',
      '/designs/TraderLab/05.avif',
    ],
    privacyPath: '/apps/Trader_lab/privacy',
    termsPath: '/apps/Trader_lab/termofuse',
    accountRemovePath: '/apps/trader_lab/accountremove',
  },
  {
    slug: 'brainiq',
    name: 'BrainIQ: Boost Your Mind',
    nameIos: 'BrainIQ: Boost Your Mind',
    nameAndroid: 'BrainIQ: Boost Your Mind',
    tagline: 'Sharpen your mind with cognitive training',
    description:
      'How sharp is your brain today? Test memory, attention, and reaction speed with score-based quizzes and fun daily challenges. Train consistently, track your results over time, and see exactly what your mind is capable of.',
    platforms: ['ios', 'android'],
    appStoreUrl: '#',
    googlePlayUrl: '#',
    icon: null,
    accentColor: '#560BAD',
    features: ['20+ brain training games', 'Daily IQ score', 'Progress analytics', 'Personalized training plan'],
    screenshots: [],
    privacyPath: '/apps/brainiq/privacy',
    termsPath: '/apps/BrainIQ/termofuse',
    accountRemovePath: '/apps/brainiq/accountremove',
  },
  {
    slug: 'schedula',
    name: 'Schedula',
    nameIos: 'Schedula',
    nameAndroid: 'Schedula',
    tagline: 'Smart schedule organizer for busy people',
    description:
      'Your day, blocked by time. Add tasks with start and end times, set reminders that actually fire when you need them, and see your whole week at a glance. No bloat, no subscriptions to dig through — just a fast, clean planner that fits your real life.',
    platforms: ['ios', 'android'],
    appStoreUrl: '#',
    googlePlayUrl: '#',
    icon: '/designs/icons/Schedula.avif',
    accentColor: '#4361EE',
    features: ['Timetable & calendar view', 'Smart deadline reminders', 'Task priority system', 'Team schedule sharing'],
    screenshots: [
      '/designs/Schedula/01.avif',
      '/designs/Schedula/02.avif',
      '/designs/Schedula/03.avif',
      '/designs/Schedula/04.avif',
      '/designs/Schedula/05.avif',
    ],
    privacyPath: '/apps/schedula/privacy',
    termsPath: '/apps/Schedula/termofuse',
    accountRemovePath: '/apps/schedula/accountremove',
  },
  {
    slug: 'receipto',
    name: 'Receipto',
    nameIos: 'Receipto',
    nameAndroid: 'Receipto',
    tagline: 'Scan and organize receipts digitally',
    description:
      'Paper receipts pile up fast — digital ones don\'t. Scan any receipt in seconds, apply a clean filter, attach a note and amount, then export as PDF or image. Your records, organized and always findable — no filing cabinet required.',
    platforms: ['ios', 'android'],
    appStoreUrl: '#',
    googlePlayUrl: '#',
    icon: '/designs/icons/receipo.avif',
    accentColor: '#16A34A',
    features: ['Instant OCR scanning', 'Auto expense categorization', 'Export to CSV & PDF', 'Tax report generator'],
    screenshots: [
      '/designs/Receipto/prv_cover_01.avif',
      '/designs/Receipto/prv_cover_02.avif',
      '/designs/Receipto/prv_cover_03.avif',
      '/designs/Receipto/prv_cover_04.avif',
      '/designs/Receipto/prv_cover_05.avif',
    ],
    privacyPath: null,
    termsPath: null,
    accountRemovePath: null,
  },
  {
    slug: 'pureblock',
    name: 'PureBlock',
    nameIos: 'PureBlock',
    nameAndroid: 'PureBlock',
    tagline: 'Block ads, trackers, and distractions',
    description:
      'Ads slow you down. PureBlock clears them out. Enable the Safari Content Blocker, toggle ad and tracker rules on or off, and get a faster, cleaner browsing experience — no VPN setup, no account required, no nonsense.',
    platforms: ['ios', 'android'],
    appStoreUrl: '#',
    googlePlayUrl: '#',
    icon: '/designs/icons/PureBlock.avif',
    accentColor: '#DC2626',
    features: ['Ad blocking across all apps', 'Tracker & malware prevention', 'Custom block lists', 'Screen time reports'],
    screenshots: [
      '/designs/PureBlock/prv_cover_01.avif',
      '/designs/PureBlock/prv_cover_02.avif',
      '/designs/PureBlock/prv_cover_03.avif',
      '/designs/PureBlock/prv_cover_04.avif',
      '/designs/PureBlock/prv_cover_05.avif',
    ],
    privacyPath: null,
    termsPath: null,
    accountRemovePath: null,
  },
];

export const getAppBySlug = (slug) => APPS.find((app) => app.slug === slug);
